document.addEventListener('DOMContentLoaded', function () {
  const dropdownToggles = document.querySelectorAll('.mobile-menu-items #primary-menu li.menu-item a.dropdown-toggle');

  dropdownToggles.forEach(function (toggle, index) {
    toggle.addEventListener('click', function (event) {
      event.preventDefault();

      // Close other open dropdowns
      const openDropdowns = document.querySelectorAll('.dropdown-menu.show');
      openDropdowns.forEach(function (dropdown, i) {
        dropdown.classList.remove('show');
        dropdown.style.transitionDelay = `-${(openDropdowns.length - i - 1) * 100}ms`;
      });

      // Toggle the current dropdown
      const dropdownMenu = toggle.nextElementSibling;
      dropdownMenu.style.transitionDelay = `${(dropdownToggles.length - index - 1) * 100}ms`;
      dropdownMenu.classList.toggle('show');
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (event) {
    const dropdownMenus = document.querySelectorAll('.dropdown-menu');
    dropdownMenus.forEach(function (menu, index) {
      if (!menu.classList.contains('show')) return;

      if (!menu.parentElement.contains(event.target) && !event.target.classList.contains('dropdown-toggle')) {
        menu.classList.remove('show');
        menu.style.transitionDelay = `-${(dropdownMenus.length - index - 1) * 100}ms`;
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.js-sticky');
  if (!header) return;

  // Kada sticky počinje (može biti 0 ili visina hero-a, itd.)
  const stickyStart = header.offsetTop;

  let lastY = window.scrollY;
  let ticking = false;

  // Minimalna promjena (px) da ne treperi na sitnim pomacima touchpada
  const deltaThreshold = 6;

  const setState = (y) => {
    const isSticky = y > stickyStart;

    if (!isSticky) {
      // Vrati u “normalno” stanje (absolute)
      header.classList.remove('is-sticky', 'is-hidden');
      header.classList.add('is-visible');
      return;
    }

    // Sticky mode
    header.classList.add('is-sticky');

    const delta = y - lastY;

    // Ako smo pri vrhu sticky zone, pokaži
    if (y <= stickyStart + 10) {
      header.classList.remove('is-hidden');
      header.classList.add('is-visible');
      lastY = y;
      return;
    }

    // Skrol dolje -> sakrij, skrol gore -> pokaži
    if (Math.abs(delta) >= deltaThreshold) {
      if (delta > 0) {
        // down
        header.classList.remove('is-visible');
        header.classList.add('is-hidden');
      } else {
        // up
        header.classList.remove('is-hidden');
        header.classList.add('is-visible');
      }
    }

    lastY = y;
  };

  const onScroll = () => {
    const y = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        setState(y);
        ticking = false;
      });
      ticking = true;
    }
  };

  // Init (refresh mid-scroll)
  header.classList.add('is-visible');
  setState(window.scrollY);

  window.addEventListener('scroll', onScroll, { passive: true });
});